export const ACCORDION_ENDHANCER_ICON_SIZE = 12;
